export const translations = {
  en: {
    header: 'Easy Genogram JP',
    load: 'Load',
    save: 'Save',
    tools: 'Tools',
    select: 'Select',
    erase: 'Erase',
    deceased: 'Deceased',
    boundary: 'Household',
    textTool: 'Text',
    shapes: 'Shapes',
    male: 'Male',
    female: 'Female',
    indexM: 'Index M',
    indexF: 'Index F',
    lines: 'Lines',
    solidLine: 'Solid Line',
    dotted: 'Dotted',
    separation: 'Separation',
    divorce: 'Divorce',
    lineThickness: 'Line Thickness',
    thin: 'Thin',
    medium: 'Medium',
    thick: 'Thick',
    fontSize: 'Font Size',
    small: 'Small',
    large: 'Large',
    tip: "Tip: Double-click an element to edit. Select & press 'Delete' to remove. Shift+Click to multi-select.",
    loadError: 'Please select a valid JSON file with genogram data.',
    cancel: 'Cancel',
    undo: 'Undo',
    redo: 'Redo',
    delete: 'Delete',
    cohabitation: 'Cohabitation',
    enterName: 'Enter name (current: {{current}})',
    enterAge: 'Enter age (current: {{current}})',
    enterText: 'Enter text',
    enterLabel: 'Enter household label (current: {{current}})',
    cohabitingTool: 'Boundary',
    cohabitingCaption: 'Boundary',
    saveOptions: 'Save Options',
    saveAsSVG: 'Save as SVG',
    saveAsPNG: 'Save as PNG',
    pngSaveError: 'Failed to save as PNG. Please try again.',
    paddingPx: 'Padding (px)',
    toggleGrid: 'Grid',
    includeBackground: 'Include white background',
    captionSelect: 'Select',
    captionErase: 'Erase',
    captionText: 'Text',
    captionMale: 'Male',
    captionFemale: 'Female',
    captionIndexM: 'IndexM',
    captionIndexF: 'IndexF',
    captionSolid: 'Solid',
    captionDashed: 'Dashed',
    captionSep: 'Sep.',
    captionDiv: 'Div.',
    captionDec: 'Dec.',
    captionHouse: 'House',
    captionBound: 'Bound.',
  },
  ja: {
    header: 'Easy Genogram JP',
    load: '読込',
    save: '保存',
    tools: 'ツール',
    select: '選択',
    erase: '消しゴム',
    deceased: '故人',
    boundary: '同居',
    textTool: 'テキスト',
    shapes: '図形',
    male: '男性',
    female: '女性',
    indexM: '本人(男)',
    indexF: '本人(女)',
    lines: '線',
    solidLine: '実線',
    dotted: '点線',
    separation: '分離',
    divorce: '離婚',
    lineThickness: '線の太さ',
    thin: '細い',
    medium: '中',
    thick: '太い',
    fontSize: 'フォントサイズ',
    small: '小',
    large: '大',
    tip: "ヒント: ダブルクリックで編集。選択して 'Delete' で削除。Shift+クリックで複数選択。",
    loadError: '有効なジェノグラムデータを含むJSONファイルを選択してください。',
    cancel: 'キャンセル',
    undo: '元に戻す',
    redo: 'やり直し',
    delete: '削除',
    cohabitation: '同居',
    enterName: '名前を入力 (現在: {{current}})',
    enterAge: '年齢を入力 (現在: {{current}})',
    enterText: 'テキストを入力',
    enterLabel: '同居のラベルを入力 (現在: {{current}})',
    cohabitingTool: '囲い',
    cohabitingCaption: '囲い',
    saveOptions: '保存オプション',
    saveAsSVG: 'SVGとして保存',
    saveAsPNG: 'PNGとして保存',
    pngSaveError: 'PNGでの保存に失敗しました。もう一度お試しください。',
    paddingPx: '余白 (px)',
    toggleGrid: 'グリッド',
    includeBackground: '背景を白にする',
    captionSelect: '選択',
    captionErase: '消す',
    captionText: '文字',
    captionMale: '男性',
    captionFemale: '女性',
    captionIndexM: '本人男',
    captionIndexF: '本人女',
    captionSolid: '実線',
    captionDashed: '点線',
    captionSep: '分離',
    captionDiv: '離婚',
    captionDec: '故人',
    captionHouse: '同居',
    captionBound: '囲い',
  },
};

export type Language = keyof typeof translations;
